import React from 'react';
import { FiStar, FiThumbsDown, FiThumbsUp, } from 'react-icons/fi'
import Navbar from '../../../@shared/navigations/default';
import { Options } from '../options';

const AccountFavoritesPage = () => {
    return (
      <>
      <Navbar />
        <div className="container3">
           <div className="">
              <div>
                 <Favorites />
              </div>
             <div>
             <div className="sticky">
                <Options 
                title='Favorites'
                path='/account/favorites' 
                 /> 
              </div>
         
                 <div style={{clear:'both'}}></div> 
             </div>
            
           
           </div>
        </div>

      </>
    )
}

export default AccountFavoritesPage
  

export const notifyTabs = [
    {title:'Last Activities', count:13, no:7 ,  endpoint:'getPassives', children:[
        {title:'Lorem ipsum dolor sit amet consectetur adipisicing elit.', avatar:"0", img:43, reviews:34, star:5, privacy:false, sector:[{title:'Job'}], job:[{title:'Career'}], era:[{title:'Space'}], user:{name:'Author',  date:'07/10/2019', like:287, dislike:37},  },
        {title:'Numquam eum fugit voluptate commodi doloremque doloribus?', avatar:4, img:44, reviews:34, star:5, privacy:true, sector:[{title:'Job'}], job:[{title:'Career'}], era:[{title:'Space'}], user:{name:'Author',  date:'07/10/2019', like:287, dislike:37},  },
        {title:'Veniam, Reprehenderit eos a recusandae enim', avatar:2, img:45, reviews:34, star:5, privacy:false, sector:[{title:'Job'}], job:[{title:'Career'}], era:[{title:'Space'}], user:{name:'Author',  date:'07/10/2019', like:287, dislike:37},  },
        {title:'Mollitia ducimus laudantium id eius', avatar:1, img:19, reviews:34, star:5, privacy:true, sector:[{title:'Job'}], job:[{title:'Career'}], era:[{title:'Space'}], user:{name:'Author',  date:'07/10/2019', like:287, dislike:37},  },
    ]},
  ];
 
export const Favorites = ({ projects,    }) => {
    return (
      <React.Fragment>
        <div className="favorite-projects">
          <ul className="notify-lines ">
            {true && (
              <ul className="children">
                {projects?.length > 0 && projects?.map((child, i) => (
                  <FavoriteItem item={child} key={'children' + i} />
                ))}
              </ul>
            )}
  
            {notifyTabs?.map((item, i) => (
              <li key={'tab' + i}>
                <div className="flex-baseline notify-line">
                  <div className="line"> <p>{item.title}</p> </div>
                  <b>{item.count}</b>
                </div>
  
                {true && (
                  <ul className="children">
                    {item?.children?.length > 0 && item.children.map((child, i) => (
                      <FavoriteItem item={child} key={'children' + i} />
                    ))}
                  </ul>
                )}
  
              </li>
            ))}
          </ul>
        </div>
      </React.Fragment>
    )
}

export const FavoriteItem = ({ item }) => {

    return (
        <li>
            <div className="favorite-item list">
                <div className="owner">
                    <div className="name">{item.user.name}</div>
                    {item.avatar && <img src={`/assets/images/faces/${item.avatar}.png`} alt={item.user.name} draggable="false" />}
                    {!item.avatar && <img src="/assets/images/faces/default.svg" alt={item.user.name} draggable="false" />}
                    <p className="date">{item.user.date}</p>
                    <div className="thumbs">
                        <div><FiThumbsUp className="up" /> {item.user.like}</div>
                        <div><FiThumbsDown className="down" /> {item.user.dislike}</div>
                    </div>
                </div>
                <div className="detail">
                    <div className="info">
                        <div className="flex">
                            <div className="title">{item.title} {item.privacy && <div className="private">Private</div>} </div>
                        </div>
                        <div className="stars">
                            <FiStar /> <FiStar /> <FiStar /> <FiStar /> <FiStar />
                            <p className="reviews">{item.reviews} Reviews</p>
                        </div>
                        {item.details && (
                            <ul>
                                <li><p>sector: </p><b>{item.detail?.sector}</b></li>
                                <li><p>type: </p><b>{item.detail?.type}</b></li>
                                <li><p>era: </p><b>{item.detail?.era}</b></li>
                            </ul>
                        )}
                    </div>
                    <div className="cover">
                        {item.img && <img src={`/assets/images/projects/${item.img}.jpg`} draggable="false" alt={item.title} />}
                    </div>
                </div>
            </div>
        </li>
    )
}
